import React from 'react';
import { Table, Divider } from 'antd';

const ug =localStorage.getItem("technology")
const exp =localStorage.getItem("second")
const pg =localStorage.getItem("tree")
const columns = [
  {
    title: 'UG Course',
    dataIndex: 'name',
  },
  {
    title: 'Job',
    dataIndex: 'age',
  },
  {
    title: 'Masters',
    dataIndex: 'address',
  },
];
const data = [
  {
    key: '1',
    name: `${ug}`,
    age: `${exp === "ExpMatchUg" ? `${ug}` : `${exp}`}`,
    address: `${pg === "similartomyug" || pg === "PgMatchUG" ? `${ug}` : `${pg}`}`
  },
];
const Buildtable = () => (
  <>    
    <Table columns={columns} dataSource={data} size="small" />
  </>
);
export default Buildtable;